import React from 'react';
import { Box, Paper, Typography, Grid } from '@mui/material';
import {
  ResponsiveContainer,
  LineChart,
  Line,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from 'recharts';

const fmt = (v) => new Intl.NumberFormat('pt-BR').format(v || 0);

const paperSx = {
  p: 2.5,
  borderRadius: 3,
  border: '1px solid rgba(25,118,210,0.15)',
  background: 'linear-gradient(180deg, #fff 0%, #f8fafc 100%)',
  height: '100%',
};

/**
 * Par linha + barras de evolução (envios / quase-falhas).
 * data: [{ label, envios, quaseFalhas }]
 */
export default function SafetyEvolucaoCharts({ data = [], title = 'Evolução' }) {
  if (!data.length) {
    return (
      <Paper elevation={0} sx={{ ...paperSx, textAlign: 'center', color: 'text.secondary' }}>
        <Typography variant="body2">Sem dados de evolução no período.</Typography>
      </Paper>
    );
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <Paper elevation={0} sx={paperSx}>
          <Typography variant="subtitle1" fontWeight={700} color="primary" sx={{ mb: 1 }}>
            {title} — linha
          </Typography>
          <Box sx={{ width: '100%', height: 280 }}>
            <ResponsiveContainer>
              <LineChart data={data} margin={{ top: 8, right: 12, left: 0, bottom: 0 }}>
                <CartesianGrid strokeDasharray="3 3" stroke="rgba(0,0,0,0.06)" />
                <XAxis dataKey="label" tick={{ fontSize: 11 }} />
                <YAxis tick={{ fontSize: 11 }} allowDecimals={false} />
                <Tooltip formatter={(v, n) => [fmt(v), n === 'envios' ? 'Envios' : 'Quase-falhas']} />
                <Legend
                  formatter={(v) => (v === 'envios' ? 'Envios' : v === 'quaseFalhas' ? 'Quase-falhas' : v)}
                />
                <Line type="monotone" dataKey="envios" stroke="#1976d2" strokeWidth={2} dot={{ r: 3 }} />
                <Line type="monotone" dataKey="quaseFalhas" stroke="#00897b" strokeWidth={2} dot={{ r: 3 }} />
              </LineChart>
            </ResponsiveContainer>
          </Box>
        </Paper>
      </Grid>
      <Grid item xs={12} md={6}>
        <Paper elevation={0} sx={paperSx}>
          <Typography variant="subtitle1" fontWeight={700} color="primary" sx={{ mb: 1 }}>
            {title} — barras
          </Typography>
          <Box sx={{ width: '100%', height: 280 }}>
            <ResponsiveContainer>
              <BarChart data={data} margin={{ top: 8, right: 12, left: 0, bottom: 0 }}>
                <CartesianGrid strokeDasharray="3 3" stroke="rgba(0,0,0,0.06)" />
                <XAxis dataKey="label" tick={{ fontSize: 11 }} />
                <YAxis tick={{ fontSize: 11 }} allowDecimals={false} />
                <Tooltip formatter={(v, n) => [fmt(v), n === 'envios' ? 'Envios' : 'Quase-falhas']} />
                <Legend
                  formatter={(v) => (v === 'envios' ? 'Envios' : v === 'quaseFalhas' ? 'Quase-falhas' : v)}
                />
                <Bar dataKey="envios" fill="#1976d2" radius={[4, 4, 0, 0]} />
                <Bar dataKey="quaseFalhas" fill="#00897b" radius={[4, 4, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          </Box>
        </Paper>
      </Grid>
    </Grid>
  );
}
